var map = {
	"./TransitionCollapse.vue": "n8kg",
	"./TransitionFade.vue": "bFDT",
	"./TransitionFadePage.vue": "7zCX",
	"./TransitionStagger.vue": "eHWn",
	"./TransitionWtf.vue": "t8cO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5VWx";


//////////////////
// WEBPACK FOOTER
// ./src/transitions .*\.(js|vue)$
// module id = 5VWx
// module chunks = 0